import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, EMPTY } from "rxjs";
import { versionInfo } from "../../../../environments/version";
import { environment } from "../../../../environments/environment";
import { LogLevel } from "./console-proxy.model";
import { blastoiseEasterEgg } from "./console-proxy.utils";
import { JwtService } from "../auth/jwt.service";

@Injectable({
	providedIn: "root"
})
export class ConsoleProxyService {
	private readonly http = inject(HttpClient);
	private readonly jwtService = inject(JwtService);

	private readonly loggerURL = environment.apiDemandUrl + "/logs/fe";

	constructor() {
		console.log(blastoiseEasterEgg);
		if (!environment.production) console.log(versionInfo);

		this.setupConsoleProxy();
	}

	private setupConsoleProxy() {
		console.log = this.createConsoleProxy(LogLevel.LOG, console.log);
		console.debug = this.createConsoleProxy(LogLevel.DEBUG, console.debug);
		console.info = this.createConsoleProxy(LogLevel.INFO, console.info);
		console.warn = this.createConsoleProxy(LogLevel.WARN, console.warn);
		console.error = this.createConsoleProxy(LogLevel.ERROR, console.error);
	}

	private createConsoleProxy(level: LogLevel, fallbackConsoleFn: (...data: unknown[]) => void) {
		return (...data: unknown[]) => {
			if (!environment.production) fallbackConsoleFn(...data);
			if (!environment.local) this.sendLogToBackend(level, ...data);
		};
	}

	private sendLogToBackend(level: LogLevel, ...data: unknown[]) {
		if (!this.jwtService.getCurrentTokenId()) return;

		this.http
			.post(this.loggerURL, {
				message: JSON.stringify(data),
				url: globalThis.location.href,
				version: JSON.stringify(versionInfo),
				level
			})
			.pipe(catchError(() => EMPTY))
			.subscribe();
	}
}
